<template>
<div>
    <div>
        <el-select v-model="pondid" clearable placeholder="请选择要查看的池塘"style="float:right">
            <el-option v-for="item in options2" 
            :key="item.id"
            :label="item.name"
            :value="item.id"></el-option> 
          </el-select> 
          <el-select v-model="comid" clearable placeholder="请选择要查看的公司" v-if = "role === '超级管理员'" style="float:right">
            <el-option v-for="item in options1" 
            :key="item.id"
            :label="item.name"
            :value="item.id"></el-option>
          </el-select>
    </div>
    <button @click="generateQRCode">生成二维码</button>
    <img ref="qrcodeImg"/>
</div>
</template>
<script>
    import QRcode from 'qrcode'

    export default {
        data(){
            return{
                text: '',
                ORcode: '',
                pondid: null,
                comid: null,
                options1:[],
                options2:[],
                form: {},
                role: (localStorage.getItem("user")?JSON.parse(localStorage.getItem("user")):{}).role,
            }
        },
        mounted () {
            //请求分页查询
            // this.load()
            if(this.role == "超级管理员"){
            this.getcompanies()
            }else{
            this.getPonds(this.user.companyid)
            }
        },
        methods:{
            getcompanies () {
          this.request.get('/api/companies/').then(res => {
            if(res.code === "200"){
              this.options1 = res.data.map(item => {
                return {
                  id: item.id,
                  name: item.name
                }
              })
            }else{
              console.log(res.code, res.data);
            }
          })
        },
        getPonds (comid){
            if (isNaN(comid)) {  
            // 如果 comid 不是数字，则设置一个默认值或者处理错误  
            comid = 0; // 或者你可以抛出一个错误，或者根据需要处理这种情况  
            }  
            this.request.get('/api/ponds/getponds', {
                params:{
                    comid: comid
                }
            }).then(res=> {
                if(res.code === "200") {
                    this.options2 = res.data.map(item => {
                        return {
                            id: item.id,
                            name: item.name
                        }
                    })
                }else{
                    console.log(res.msg);
                }
                
            }).catch(error =>{
                console.log(error);
            })
        },
            generateQRCode() {
                const targetUrl = `http://localhost:8080/#/ORcode?comid=${this.comid}&pondid=${this.pondid}`;
                this.createQRCode(targetUrl);
        },
        createQRCode(text) {
            QRcode.toDataURL(text, { width: 200, color: { dark: '#000000', light: '#ffffff' }, margin: 1 })
                .then(url => {
                    this.$refs.qrcodeImg.src = url; // 设置 img 的 src 为生成的二维码 URL
                })
                .catch(err => {
                    console.error('生成二维码失败:', err);
                });
        }
    },
    watch: {
            comid (comid) {
            this.getPonds(comid)
            },
            pondid (pondid) {
            }
        }
    }


</script>
<style scoped>
img {
    /* 可以在这里添加一些样式来美化二维码 */
    border: 1px solid #ddd; /* 给二维码添加边框 */
    padding: 10px; /* 添加内边距 */
    background-color: #fff; /* 设置背景颜色 */
    border-radius: 4px; /* 边框圆角 */
}
</style>